import { put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { selectors, withOffset } from '../../Stream';
import { getCommissionStreamId } from '../helpers';

export default function* (): SagaIterator {
  const streamId = getCommissionStreamId();

  const isFetching: ReturnType<typeof selectors.isFetching> = yield select(
    selectors.isFetching,
    streamId
  );
  if (isFetching) {
    return;
  }

  yield put(withOffset.actions.fetch(streamId));
}
